'use client';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import './index.scss';

export interface EcoImgProps {
    /**
     * 所有分辨率展示的图片链接
     */
    pc?: string;
    /**
     * 分辨率[1024, 768]
     */
    pad?: string;
    /**
     * 分辨率[1024, 0) 或 (768, 0)
     */
    h5?: string;
    /**
     * 介绍这是个什么图片
     */
    alt?: string;
    /**
     * 样式名
     */
    className?: string;
    /**
     * 开启懒加载
     */
    isOpenLazy?: boolean;
    /**
     * 高度
     */
    height?: number;
}

/**
 * 维护:谢保林
 *
 * 图片容器
 *
 * 为提升性能,使用 background 来展示,因此使用时必须给这个容器设置高度,宽度默认为100%
 *
 * 其中只展示图片中间部分,即 background-size: cover;
 */
export default function EcoImg({ className = '', alt = 'eco-IMG', pc, pad, h5, isOpenLazy = false, height = 0 }: EcoImgProps) {
    const isOpenLazy2 = isOpenLazy; //可以临时关停
    const prefixCls = 'eco-img';
    const compCls = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-has-pad`]: pad,
    });
    const styleData: any = {
        '--eco-img-pc': `url('${pc}')`,
    };
    if (pad) {
        styleData['--eco-img-pad'] = `url('${pad}')`;
    }
    if (h5) {
        styleData['--eco-img-h5'] = `url('${h5}')`;
    }
    const boxRef = useRef<HTMLDivElement>(null);
    const [compStyle, setCompStyle] = useState<any>({});

    // 进入函数
    const enterHandle = () => {
        setCompStyle(styleData);
    };

    useEffect(() => {
        if (boxRef.current && isOpenLazy2) {
            const options = {
                rootMargin: '600px', //偏移量,-100px表示从底部伸出100px了
                threshold: 0, //0 - 1;0表示监听元素有部分进入了可视区
            };

            const observer = new IntersectionObserver((entries) => {
                for (let i = 0; i < entries.length; i++) {
                    const elem = entries[i];

                    if (elem.isIntersecting && elem.boundingClientRect.top > 0) {
                        enterHandle();
                        observer.unobserve(boxRef.current as Element);
                    } else if (elem.isIntersecting && elem.boundingClientRect.top < 0) {
                        enterHandle();
                        observer.unobserve(boxRef.current as Element);
                    } else if (!elem.isIntersecting && elem.boundingClientRect.top > 0) {
                        //console.log("leave", "从底部离开");
                    } else {
                        //console.log("leave", "从顶部离开");
                    }
                }
            }, options);

            observer.observe(boxRef.current);
        }
    }, []);
    if (!pc) {
        return null;
    }

    return (
        <div className={compCls} style={isOpenLazy2 ? compStyle : styleData} ref={boxRef}>
            {h5 && <figure className={`${prefixCls}-item ${prefixCls}-item-h5`} aria-label={alt}></figure>}
            {pad && <figure className={`${prefixCls}-item ${prefixCls}-item-pad`} aria-label={alt}></figure>}
            <figure className={`${prefixCls}-item ${prefixCls}-item-pc`} aria-label={alt}></figure>
        </div>
    );
}
